import React from "react";

import MobileGuideRunner from "../base/MobileGuideRunner";

import { jasperSavedFiltersForMobile } from "./configuration";

const JasperSavedFiltersForMobile = () => {
  return <MobileGuideRunner descriptor={jasperSavedFiltersForMobile} />;
};

export default JasperSavedFiltersForMobile;
